function userStartedStreamEventAdapter(data) {
  const {
    peerId,
    id,
    producer,
    name,
    fullName,
    userId,
    user_id: userIdSnakeCase,
    isTeacher,
    is_teacher: isTeacherSnakeCase,
  } = data.room.peer;

  return {
    peerId: peerId ?? id,
    producer,
    name: name || fullName || 'Неизвестное имя',
    userId: userId ?? userIdSnakeCase ?? null,
    isTeacher: isTeacher ?? isTeacherSnakeCase ?? false,
    adapted: true,
  };
}

export default userStartedStreamEventAdapter;
